import { Badge, type BadgeVariant } from '@ohear/ui'
import type { RtRole } from '../lib/rt-protocol'

const roleVariant: Record<RtRole | 'unknown', BadgeVariant> = {
  studio: 'blue',
  director: 'green',
  engineer: 'gray',
  actor: 'amber',
  unknown: 'gray',
}

const roleLabel: Record<RtRole | 'unknown', string> = {
  studio: 'Studio',
  director: 'Director',
  engineer: 'Engineer',
  actor: 'Actor',
  unknown: 'Guest',
}

export function RoleBadge({ role, label }: { role: RtRole | 'unknown'; label?: string }) {
  return <Badge variant={roleVariant[role]}>{label ?? roleLabel[role]}</Badge>
}
